// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@lfx/shared/shared.module';
import { ProfileSnapshotEmployeeMeetingsComponent } from './components/profile-snapshot-employee-meetings/profile-snapshot-employee-meetings.component';
import { ProfileSnapshotEmployeeSubscriptionsComponent } from './components/profile-snapshot-employee-subscriptions/profile-snapshot-employee-subscriptions.component';
import { ProfileSnapshotEmployeeTrainingComponent } from './components/profile-snapshot-employee-training/profile-snapshot-employee-training.component';
import { ProfileSnapshotEmployeeEventsComponent } from './components/profile-snapshot-employee-events/profile-snapshot-employee-events.component';
import { ProfileSnapshotEmployeeTechnicalComponent } from './components/profile-snapshot-employee-technical/profile-snapshot-employee-technical.component';

@NgModule({
  declarations: [
    ProfileSnapshotEmployeeMeetingsComponent,
    ProfileSnapshotEmployeeSubscriptionsComponent,
    ProfileSnapshotEmployeeTrainingComponent,
    ProfileSnapshotEmployeeEventsComponent,
    ProfileSnapshotEmployeeTechnicalComponent,
  ],
  imports: [CommonModule, SharedModule],
  exports: [
    ProfileSnapshotEmployeeMeetingsComponent,
    ProfileSnapshotEmployeeSubscriptionsComponent,
    ProfileSnapshotEmployeeTrainingComponent,
    ProfileSnapshotEmployeeEventsComponent,
    ProfileSnapshotEmployeeTechnicalComponent,
  ],
})
export class ProfileSnapshotChildrenModule {}
